export let EclipsePackagePickerSteps = /*#__PURE__*/function (EclipsePackagePickerSteps) {
  EclipsePackagePickerSteps["SELECT_PLAN"] = "select-plan";
  EclipsePackagePickerSteps["SELECT_CYCLE"] = "select-cycle";
  EclipsePackagePickerSteps["CHECKOUT"] = "checkout";
  EclipsePackagePickerSteps["ANY"] = "*";
  EclipsePackagePickerSteps["EMPTY"] = "";
  return EclipsePackagePickerSteps;
}({});
export let FeatureNamespace = /*#__PURE__*/function (FeatureNamespace) {
  FeatureNamespace["STICKY"] = "sticky";
  FeatureNamespace["MAIN"] = "main";
  FeatureNamespace["SECONDARY"] = "secondary";
  return FeatureNamespace;
}({});
//# sourceMappingURL=types.js.map